import React from 'react';
import { useTranslation } from 'react-i18next';
import U2000DeleteRecordDialog from '../../../u2000Core/components/dialog/U2000DeleteRecordDialog';
import { NS } from '../../U3147';
import type { U3147TimeSession } from '../../U3147Service';
import { u3147FormatProjectLabel } from '../../U3147Service';
import { u3147FormatTimeFromIso } from '../../tools/u3147FormatDuration';

export interface U3147SessionDeleteDlgProps {
  isOpen: boolean;
  sessions: U3147TimeSession[];
  onClose: (result: 'yes' | 'no') => void;
}

const U3147SessionDeleteDlg: React.FC<U3147SessionDeleteDlgProps> = ({ isOpen, sessions, onClose }) => {
  const { t } = useTranslation();
  if (!isOpen || sessions.length === 0) return null;

  const multiple = sessions.length > 1;

  return (
    <U2000DeleteRecordDialog
      isOpen={isOpen}
      onClose={onClose}
      title={t('lblDeleteRange', { ns: NS, defaultValue: 'Supprimer la plage' })}
    >
      <p className="mb-4">
        {multiple
          ? t('msgConfirmDeleteRanges', {
              ns: NS,
              count: sessions.length,
              defaultValue: 'Voulez-vous supprimer les {{count}} plages sélectionnées ?',
            })
          : t('msgConfirmDeleteRange', {
              ns: NS,
              defaultValue: 'Voulez-vous supprimer cette plage ?',
            })}
      </p>
      <div className="mt-2 flex max-h-48 flex-col gap-1 overflow-y-auto">
        {sessions.map((session) => {
          const label = `${u3147FormatTimeFromIso(session.startedAt)} – ${u3147FormatTimeFromIso(session.endedAt)} · ${u3147FormatProjectLabel(session.project as never)}`;
          return (
            <span key={session.id} className="text-sm text-gray-800">
              {label}
            </span>
          );
        })}
      </div>
    </U2000DeleteRecordDialog>
  );
};

export default U3147SessionDeleteDlg;
